import React, { useEffect, useState } from 'react';
import ProductSubCategoryModel from './models/ProductSubCategoryModel';
import ProductSubCategoryDetailsFields from './ProductSubCategoryDetailsFields';

function AddProductSubCategory({ sendDataToParent, onLoad }) {
  const [formData, setFormData] = useState(new ProductSubCategoryModel());
  const [slugManual, setSlugManual] = useState(false);

  useEffect(() => {
    const initial = new ProductSubCategoryModel();
    if (onLoad) onLoad(initial);
    if (sendDataToParent) sendDataToParent(initial);
  }, []);

  const handleData = (data) => {
    setFormData(data);
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <ProductSubCategoryDetailsFields
        formData={formData}
        sendDataToParent={handleData}
        slugManual={slugManual}
        onSlugManualChange={setSlugManual}
      />
    </div>
  );
}

export default AddProductSubCategory;
